var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8783 0.536896L70.5233 62.8502L41.9573 69.7818L13.47 62.8598L7.12164 0.536896H76.8783Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 64.4833L65.0828 58.8821L70.5132 5.63245H42V64.4833Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6461 20.92H42V13.2763H20.1023L20.3112 15.3269L22.4577 36.3908H42V28.7472H30.4442L29.6461 20.92ZM31.6143 40.2128H22.8479L24.0712 52.2145L41.9598 56.5608L42 56.5512V48.5986L41.9617 48.6074L32.2361 46.3089L31.6143 40.2128Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9699 36.3908H52.7234L51.7094 46.3041L41.9696 48.605V56.5572L59.8724 52.2145L60.0036 50.923L62.0561 30.7997L62.2691 28.7472H41.9699V36.3908ZM41.9699 20.9013V20.92H63.0637L63.2387 19.202L63.6368 15.3269L63.8454 13.2763H41.9699V20.9013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosHtml5);
export default __webpack_public_path__ + "static/media/logos_html-5.a19f7d29e5178037e17a2654fe04c5ad.svg";
export { ForwardRef as ReactComponent };